module.exports = __webpack_public_path__ + "static/media/044.3ac97403.jpg";